import { Reveal } from "@/components/motion/Reveal";
import { ButtonLink } from "@/components/common/ButtonLink";

// "Partner with SPC": two entry paths that pre-select the contact topic.
export const PartnerPaths = ({ paths = [] }) => (
  <div className="grid gap-6 md:grid-cols-2" data-testid="partner-paths">
    {paths.map((p, i) => (
      <Reveal
        key={p.id}
        delay={i * 0.1}
        className={`flex flex-col p-8 sm:p-12 ${i ? "bg-ink text-paper" : "spec-corners border border-line bg-surface text-ink"}`}
        data-testid={`partner-path-${p.id}`}
      >
        <span className={`font-mono text-[12px] uppercase tracking-[0.2em] ${i ? "text-paper/75" : "text-accent"}`}>Path {String.fromCharCode(65 + i)}</span>
        <h3 className="mt-8 font-display text-3xl font-semibold leading-tight tracking-[-0.035em] sm:text-4xl">{p.title}</h3>
        <p className={`mt-5 max-w-md text-[15px] leading-relaxed ${i ? "text-paper/80" : "text-muted"}`}>{p.body}</p>
        <div className="mt-auto pt-10">
          <ButtonLink to={`/contact?topic=${encodeURIComponent(p.topic)}`} variant={i ? "accent" : "primary"} testId={`partner-path-${p.id}-button`}>
            {p.button}
          </ButtonLink>
        </div>
      </Reveal>
    ))}
  </div>
);
